import React from "react";
import "../../styles/fonts.css";
import ai from "../../img/academic_icon.png";
import ei from "../../img/exx_icon.png";
import yt from "../../img/youtube_icon.png";
import fi from "../../img/filter_icon.jpg";
import aci from "../../img/account_icon.png";

const Sidedata = [
  {
    title: "Academic",
    img: ai,
    body: "Video lecture,Presentaion,Notes and other Material by professers,TAs And Students related to Academics.",
  },
  {
    title: "Extracurricular",
    img: ei,
    body: "Content by any Club,Society,Group or Student related to skill development,not considerd in Academics.",
  },
  {
    title: "Youtube",
    img: yt,
    body: "Suggested useful material and series on youtube related to both Academics and Non-Academics to make your life easy.",
  },
  {
    title: "Filter Option",
    img: fi,
    body: "Enables you to get the filtered desired content you wish to see and makes your search easy.",
  },
  {
    title: "Account",
    img: aci,
    body: "Enables you to manage you account details, the skills that you're proficient in and help us to show the default content",
  },
]
const Sidecard = (props) => {
  return (
    <div className='card text-white bg-dark mb-3 col-6 col-xl-12 col-lg-12 mx-auto'>
      <img src={props.img} className='card-img-top size-3-4-coditional mx-auto mt-1' alt='...' />
      <h4 className='card-header upperfont text-center r-size-head px-0'>{props.title}</h4>
      <div className='card-body px-0 text-center'>
        <p className='card-text fontcool r-size-body'>
          {props.body}
    </p>
      </div>
    </div>
  );
};
const Sidebar = () => {
  return (
    <div>
      <div className='row'>
        <div className='card text-white bg-dark mb-3 col-12'>
          <div className='card-body px-2 mx-auto'>
            <h4 className='card-text upperfont '>Working of platform</h4>
          </div>
        </div>
        {Sidedata.map((val)=>{
          return(
          <Sidecard 
            title = {val.title}
            img = {val.img}
            body = {val.body}
          />
          );
        })}
      </div>
    </div>
  );
};

export default Sidebar;
